import { Fragment } from 'react/jsx-runtime'
import { getMessage } from '../../utils/messageUtils'
import { AlertTime } from '../../utils/recipeUtils'
import type { User } from '../../utils/loginUtils'

interface AlertInputProps {
  user: User
  alert: string
  setAlert: (alert: string) => void
  alertTime: AlertTime | null
  setAlertTime: (alertTime: AlertTime) => void
  isMobile: boolean
}
function AlertInput({
  user,
  alert,
  setAlert,
  alertTime,
  setAlertTime,
  isMobile,
}: AlertInputProps) {
  const generateAlertTimeOptions = () => {
    return (
      <Fragment>
        <option value={AlertTime.SAME_DAY_MORNING}>
          {getMessage('recipe_same_day_morning')}
        </option>
        <option value={AlertTime.PREVIOUS_DAY_MORNING}>
          {getMessage('recipe_previous_day_morning')}
        </option>
        <option value={AlertTime.PREVIOUS_DAY_NIGHT}>
          {getMessage('recipe_previous_day_night')}
        </option>
      </Fragment>
    )
  }

  if (!user.alerts) return null

  const labelClass = `pop-up-form-label ${isMobile ? 'pop-up-form-label-mobile' : ''}`
  const fieldClass = `pop-up-form-field ${isMobile ? 'pop-up-form-field-mobile' : ''}`

  return (
    <Fragment>
      <div className="pop-up-form-row">
        <span className={labelClass}>{getMessage('recipe_alert')}:</span>
        <input
          className={fieldClass}
          type="text"
          placeholder={getMessage('recipe_alert')}
          value={alert}
          onChange={e => setAlert(e.target.value)}
        />
      </div>
      {alert.trim() != '' && (
        <div className="pop-up-form-row">
          <span className={labelClass}>{getMessage('recipe_alert_type')}:</span>
          <select
            className={fieldClass}
            value={alertTime ?? ''}
            onChange={e => setAlertTime((e.target.value as AlertTime) || null)}
          >
            {generateAlertTimeOptions()}
          </select>
        </div>
      )}
    </Fragment>
  )
}

export default AlertInput
